export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-9808QFHD_white-2b840fbeaf0acd31c77eabbfd726debf.webp";